<template>
    <el-container>
      <el-header height="60px" class="top">
        <header class="yh_header">
          <!-- <div class="yh_header_logo txt_center left">logo</div> -->
          <p class="left yh_header_title">
            <router-link to="/Index">北京社科联文献资料系统</router-link>
            <span
            style="position: relative;top: -5px;left: 5px; color:#FFF;font-size:12px;border: 1px solid;"
          >测试版</span>
          </p>
          <div class="yh_header_login right txt_right">
            <span v-if="!$store.state.userName == '' || !$store.state.userName == null">{{$store.state.userName}} &nbsp;|&nbsp;</span>
            <span>
              <router-link v-if="$store.state.userName == '' || $store.state.userName == null" to="/Login">登录</router-link>
              <router-link v-else to="/Login">退出</router-link>
            </span>
            <!-- <span><router-link to="/Login">登录</router-link></span> -->
            <!-- &nbsp;&nbsp;|&nbsp; -->
							<!-- <span><router-link to="/register">注册</router-link></span> -->
          </div>
        </header>
      </el-header>
      <el-main class="no_padding app_main_box">
        <div class="app_main">
          <router-view></router-view>
        </div>
        
      </el-main>
      <el-footer height="80px" class="yh_footer txt_center">
        北京社会科学界联合会版权所有 ，未经书面授权禁止使用 <br />
        Copyright &#169 2018 by www.bjskl.gov.cn. all rights reserved
      </el-footer>
    </el-container>

</template>

<script>
export default {
		name: 'App',
		data() {
			return {
				userName: "登录",
				if_show_: false
			}
		},
    destroyed() {
        localStorage.removeItem("doc_token")
        localStorage.removeItem("doc_name")
        localStorage.removeItem("doc_userid")
    }
	}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  min-height: 100%;
}
.yh_header {
  width: 1000px;
  margin: 0 auto;
  height: 100%;
  padding: 7px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 46px;
}
.yh_header_logo {
  width: 99px;
  height: 46px;
  background: #ffffff;
  color: black;
}
.yh_header_title a {
  font-size: 24px;
  color: #ffffff;
  text-decoration: none;
}
.yh_header_login {
  width: 100px;
}
.yh_header_login .router-link-exact-active.router-link-active {
  color: #ffffff;
  text-decoration: none;
}
.yh_header_login a {
  color: #ffffff;
  text-decoration: none;
}
.app_main_box {
  background: #eeeeee;
  width: 100%;
  height: auto;
  overflow: hidden;
}

/* .app_main {
    
    width: 1000px;
    margin: 0 auto;
} */
.yh_footer {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 18px 0;
  background: #333333;
  color: #ffffff;
  line-height: 22px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue